import { selectIsPlatformAdmin } from '@/redux/api/seletors/select-is-platform-admin';
import { AppGetState } from '@/redux/store';
import { GetUnassociatedDevicesQueryArg } from '../types/query-arg';
import { GetUnassociatedDevicesQueryParams } from '../types/query-params';

export const getUnassociatedDevicesQueryParams = (
  queryArg: GetUnassociatedDevicesQueryArg,
  getState: AppGetState,
): GetUnassociatedDevicesQueryParams => {
  const isPlatformAdmin = selectIsPlatformAdmin(getState());
  return isPlatformAdmin
    ? { unitId: 'UNASSOCIATED' }
    : { organisationId: queryArg.organisationId ?? -1, unitId: 'UNASSOCIATED' };
};
